import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance,
} from './statement/HttpResponsePipeline.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance2itgh2akpxu95 as Phases_getInstance_0,
} from './request/HttpRequestPipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstance1dclwrituae7c as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from './engine/HttpClientEngineBase.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpClient$slambdaClass;
function HttpClient$slambda() {
  if (HttpClient$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.j5h_1 = this$0;
      }
      *k5h($this$intercept, call, $completion) {
        // Inline function 'kotlin.check' call
        if (!(call instanceof HttpClientCall())) {
          var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
          throw IllegalStateException().o(toString(message));
        }
        var response = yield* this.j5h_1.u5h_1.y4s(Unit_instance, call.e5i(), $completion);
        call.f5i(response);
        yield* $this$intercept.b4s(call, $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.k5h(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass = $;
  }
  return HttpClient$slambdaClass;
}
function HttpClient$slambda_0(this$0) {
  var i = new (HttpClient$slambda())(this$0);
  var l = ($this$intercept, call, $completion) => i.k5h($this$intercept, call, $completion);
  l.$arity = 2;
  return l;
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
var HttpClient$slambdaClass_0;
function HttpClient$slambda_1() {
  if (HttpClient$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.g5i_1 = this$0;
      }
      *h5i($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.c4s($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            this.g5i_1.x5h_1.f4u(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.z4s_1.e5i(), cause));
            throw cause;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.h5i(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass_0 = $;
  }
  return HttpClient$slambdaClass_0;
}
function HttpClient$slambda_2(this$0) {
  var i = new (HttpClient$slambda_1())(this$0);
  var l = ($this$intercept, it, $completion) => i.h5i($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      static i5i(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.l5h_1 = engine;
        $this.m5h_1 = userConfig;
        $this.n5h_1 = false;
        $this.o5h_1 = atomic$boolean$1(false);
        $this.p5h_1 = Job($this.l5h_1.dw().yc(Key_instance));
        $this.q5h_1 = $this.l5h_1.dw().rm($this.p5h_1);
        $this.r5h_1 = new (HttpRequestPipeline())();
        $this.s5h_1 = new (HttpResponsePipeline())();
        $this.t5h_1 = new (HttpSendPipeline())();
        $this.u5h_1 = new (HttpReceivePipeline())();
        $this.v5h_1 = AttributesJsFn(true);
        $this.w5h_1 = $this.l5h_1.j5i();
        $this.x5h_1 = new (Events())();
        $this.y5h_1 = new (HttpClientConfig())();
        $this.l5h_1.k5i($this);
        var tmp = Phases_getInstance_0().p5i_1;
        $this.t5h_1.d4t(tmp, HttpClient$slambda_0($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.m5h_1;
        $this.y5h_1.y5i(get_HttpRequestLifecycle());
        $this.y5h_1.y5i(get_BodyProgress());
        $this.y5h_1.y5i(get_SaveBody());
        if ($this$with.v5i_1) {
          $this.y5h_1.z5i('DefaultTransformers', HttpClient$lambda);
        }
        $this.y5h_1.y5i(Plugin_getInstance());
        $this.y5h_1.y5i(get_HttpCallValidator());
        if ($this$with.u5i_1) {
          $this.y5h_1.y5i(get_HttpRedirect());
        }
        $this.y5h_1.a5j($this$with);
        if ($this$with.v5i_1) {
          $this.y5h_1.y5i(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.y5h_1);
        $this.y5h_1.k5i($this);
        var tmp_0 = Phases_getInstance().b5j_1;
        $this.s5h_1.d4t(tmp_0, HttpClient$slambda_2($this));
        return $this;
      }
      static g5j(engine, userConfig, manageEngine) {
        var $this = this.i5i(engine, userConfig);
        $this.n5h_1 = manageEngine;
        if ($this.n5h_1) {
          if (engine instanceof HttpClientEngineBase()) {
            engine.j5j_1.atomicfu$incrementAndGet();
          }
          var tmp = ensureNotNull($this.q5h_1.yc(Key_instance));
          tmp.gx((cause) => {
            var tmp;
            if (!(engine instanceof HttpClientEngineBase())) {
              tmp = true;
            } else {
              tmp = engine.j5j_1.atomicfu$decrementAndGet() <= 0;
            }
            var shouldClose = tmp;
            var tmp_0;
            if (shouldClose) {
              var tmp_1;
              if (cause == null) {
                engine.l6();
                tmp_1 = Unit_instance;
              } else {
                var tmp0_elvis_lhs = cause instanceof CancellationException() ? cause : null;
                cancel(engine, tmp0_elvis_lhs == null ? CancellationException().p('Client scope is canceled', cause) : tmp0_elvis_lhs);
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            return Unit_instance;
          });
        }
        return $this;
      }
      dw() {
        return this.q5h_1;
      }
      *m5j(builder, $completion) {
        this.x5h_1.f4u(get_HttpRequestCreated(), builder);
        var tmp = yield* this.r5h_1.y4s(builder, builder.q5j_1, $completion);
        return tmp instanceof HttpClientCall() ? tmp : THROW_CCE();
      }
      l6() {
        var success = this.o5h_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.v5h_1.l4n(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.s4n().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var plugin = installedFeatures.l4n(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.l6();
          }
        }
        this.p5h_1.v12();
      }
      toString() {
        return 'HttpClient[' + toString(this.l5h_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [CoroutineScope(), AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().g5j(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.t5j(config.t5i_1);
  return HttpClient().g5j(engine, config, true);
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
